export enum OtelAgentSelectionMode {
  ANY = 'ANY',
  ONLY_MY_AGENT = 'ONLY_MY_AGENT',
}
